import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";

import "./page-title.scss";

const PageTitle = props => {
  const { children, className, ...rest } = props;

  return (
    <h1 {...rest} className={cn("page-title", className)} tabIndex="-1">
      {children}
    </h1>
  );
};

PageTitle.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired
};

PageTitle.defaultProps = {
  className: ""
};

export default PageTitle;
